import script from "./form-module.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-module.vue?vue&type=script&setup=true&lang=ts"

import "./form-module.vue?vue&type=style&index=0&id=666322ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666322ca"]])

export default __exports__